import { post,put,del,get } from './axios'

export const expertList = async (params) => {
  const { status, data } = await get("/expert/selectExpertAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const getExpertDetail = async (params) => {
  const { status, data } = await get("/expert/selectExpertDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const updateExpertViewCount = async (params) => {
  const { status, data } = await post("/expert/updateViewCountAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const getReferenceDetail = async (params) => {
  const { status, data } = await get("/room/selectReferenceDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const referencList = async (params) => {
  const { status, data } = await get("/room/selectReferenceAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const updateViewCount = async (params) => {
  const { status, data } = await post("/room/updateViewCountAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const selectLibrary = async (params) => {
  const { status, data } = await get("/room/selectLibraryAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const referencechildren = async (params) => {
  const { status, data } = await get("/room/childrenAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

// export const selectMatrix = async (params) => {
//   const { status, data } = await get("/room/selectMatrix", params)

//   if (status === 200 || status === 201) {
//       return data
//   }
  
// }